import { OrderByDirection } from '@angular/fire/firestore';
import { CommonConstants as CC } from 'src/app/constants/common.constants';
export interface OrderBy {
    field: string;
    isDesc: boolean;
}
export const getDirection = (orderBy: OrderBy): OrderByDirection =>
    orderBy.isDesc ? CC.DESC : CC.ASC;
